/**
 * 第三方账户换绑手机号
 * */
import React, { Fragment, PureComponent } from 'react';
import IframeModal from '../iframModal/IframModal';
import {
  _h5_link_to,
  _link_kf,
  _show_login_modal,
  _anly_seng_custom,
} from '../../store/Action';
import qs from 'qs';
import { message } from 'antd';
import HTTP from '../../script/service';
import ChangeBindPhoneAuth from './ChangeBindPhoneAuth';

export default class OtherChangeBindPhone extends PureComponent {
  showModal = () => {
    window.onSuccess = window.loginSuccessUnBindPhone = null;

    window.loginSuccessUnBindPhone = (token, register) => {
      register == 1 && this.changeBindPhoneAuthElement.hideWXModal();
      register == 2 && this.changeBindPhoneAuthElement.hideQQModal();
      this.postCheckToken(token, register);
    };
    // /account-change-phone
    // http://localhost:6969
    _h5_link_to('/account-change-phone').then((res) => {
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
    });
    window.onSuccess = (msg) => {
      if (typeof msg.data === 'string') {
        if (msg.data === 'QQEvokeAuthWD') {
          // QQ 纬度 授权
          this.changeBindPhoneAuthElement.QQSecondaryModal();
        }
        if (msg.data === 'WXEvokeAuthWD') {
          // 微信 纬度 授权
          this.changeBindPhoneAuthElement.WXSecondaryModal();
        }
        if (msg.data === 'openLoginPage') {
          // 跳转原生登录页面
          window.loginSuccessUnBindPhone = null;
          this.iframeElement.hideModal();
          const { uid, token } = this.props.base;
          // 没有登录的话弹出登录弹窗
          if (!(uid && token)) {
            _show_login_modal();
          }
        }
        if (msg.data === 'openServicePage') {
          // 跳转原生登录页面
          _link_kf();
        }
      }
    };
    window.addEventListener('message', window.onSuccess);
  };

  // 验证 TOKEN
  postCheckToken = (token, register) => {
    if (!register || !token) {
      message.warning('登录失败，请稍后重试');
      return;
    }
    const params = {
      token,
      register,
      userAgentType: 'WD',
    };
    HTTP._check_token_wd_bind(params)
      .then((res) => {
        if (res.code == 200) {
          this.loginSuccessPostMessage(res);
        } else {
          _anly_seng_custom(1001, { data: res });
        }
      })
      .catch((error) => {
        message.error('网络错误，请稍后重试');
      });
  };

  // 登录成功，给 H5 传递数据
  loginSuccessPostMessage = (data) => {
    const authIframe = this.iframeElement.getIframeElement();
    if (authIframe.contentWindow && authIframe.contentWindow.postMessage) {
      authIframe.contentWindow.postMessage(
        {
          key: 'parentAuthSuccess',
          value: JSON.stringify(data),
        },
        '*'
      );
    }
  };

  iframeDestroy = () => {
    // 销毁监听
    window.removeEventListener('message', window.onSuccess);
  };

  render() {
    return (
      <Fragment>
        {/* 原第三方绑定手机号授权 */}
        <ChangeBindPhoneAuth
          base={this.props.base}
          loginSuccessPostMessage={this.loginSuccessPostMessage}
          ref={(el) => (this.changeBindPhoneAuthElement = el)}
        />

        {/* 通用弹窗 */}
        <IframeModal
          wrappedComponentRef={(el) => (this.iframeElement = el)}
          destroy={this.iframeDestroy}
        />
      </Fragment>
    );
  }
}
